// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';


export default {
    async fetchAllDevices(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/devices?page=1&per_page=1000`, config);
            ctx.commit('updateAllDevicesList', response.data) ;
            
        } catch (error) {
            return error;
        }
    },
    async fetchDevicesListBySystemId(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/devices/by-system/${id}`, config);
            ctx.commit('updateDevicesList', response.data) ;
        } catch (error) {
            return error;
        }
    },

    async saveCurrentDeviceFilter({commit}, device){
        localStorage.setItem('currentDevice', JSON.stringify(device))
        commit('updateCurrentDevice', device)
    },
    async getCurrentDeviceFilter({commit}){
        let device = localStorage.getItem('currentDevice')
        if(device){
            device = JSON.parse(device)
            commit('updateCurrentDevice', device)
        }
    },
    async saveCurrentDeviceTypeFilter({commit}, deviceType){
        localStorage.setItem('currentDeviceType', JSON.stringify(deviceType))
        commit('updateCurrentDeviceType', deviceType)
    },
    async getCurrentDeviceTypeFilter({commit}){
        let deviceType = localStorage.getItem('currentDeviceType')
        if(deviceType){
            deviceType = JSON.parse(deviceType)
            commit('updateCurrentDeviceType', deviceType)
        }
    },
    async getDevice({ commit, state, rootState, rootGetters }, { id }) {
        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };

        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/devices/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },
    async updateDevice({ commit, state, rootState, rootGetters }, payload) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/devices/${payload.id}`,
                {
                    name: payload.name,
                    system_id: payload.system_id,
                    IA_ODU_addr: payload.IA_ODU_addr,
                    IA_addr: payload.IA_addr,
                    CA_addr: payload.CA_addr,
                    type: payload.type
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Update failed'
                };
            } else if (error.request) {
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },
};
